import utils from "../../../utils/utils";
export default {
    async fetchConnectedAccounts(context, payload) {
        const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?source=${payload.source}&accountType=${payload.accountType}&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);        
        context.commit("setConnectedAccounts", response.data);
    },
    async deleteAccount(_,payload){
        await utils.utility.fetch("api/Setting/DeleteSocialMediaAccount","PUT",null, payload);        
    },
    async fetchKeywords(context, payload) {
        const response = await utils.utility.fetch(`api/Setting/GetInstagramKeywords?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);        
        context.commit("setKeywords", response.data);
    },
    async deleteInstagramKeyword(_, payload) {
        await utils.utility.fetch("api/Setting/DeleteInstagramKeyword","PUT",null, payload);        
    },
    async fetchInstagramAccounts(context,payload){
        const response = await utils.utility.fetch(`api/Setting/GetInstagramAccounts?accountId=${payload}`,"GET",null,null);        
        context.commit("setInstagramAccounts", response.data);
    },
    async addAccount(_,payload){
        await utils.utility.fetch(`api/Setting/AddInstagramAccount`,"POST",null,payload); 
    },
    async addKeyword(_,payload){
        await utils.utility.fetch(`api/Setting/AddInstagramKeyword`,"POST",null,payload); 
    }
}